import { render, staticRenderFns } from "./ImportBuildings.vue?vue&type=template&id=4ce54c88&"
import script from "./ImportBuildings.vue?vue&type=script&lang=js&"
export * from "./ImportBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports